import { type ArticleDataType, type ArticleDataTypeKeys } from './ArticleTypes';

export const isArticlesDataIndex = (
  obj: ArticleDataType,
  key: string,
): key is ArticleDataTypeKeys => {
  return obj.hasOwnProperty(key);
};
